module.exports = __webpack_public_path__ + "static/media/CouponIcon.015f0e7a.svg";